export default __webpack_public_path__ + "static/media/lock.860a3077.svg";